import React, { ReactNode } from 'react';
import { usePersona, ExperienceMode } from './usePersona';

interface PersonaGateProps {
  mode: ExperienceMode | ExperienceMode[];
  children: ReactNode;
  fallback?: ReactNode;
}

export function PersonaGate({ mode, children, fallback = null }: PersonaGateProps): React.ReactElement | null {
  const { mode: currentMode } = usePersona();
  const allowedModes = Array.isArray(mode) ? mode : [mode];

  if (allowedModes.includes(currentMode)) {
    return <>{children}</>;
  }

  return <>{fallback ?? null}</>;
}
